import type { FC, ReactNode, MouseEventHandler } from 'react';
import { ButtonStyles, ButtonContainer } from './Button.styles';
import { PlusIcon } from '@/pages/EmploymentInformation/EmploymentInformation.styles';

export interface ButtonProps {
  label: string | ReactNode;
  variant: 'primary' | 'secondary' | 'tertiary' | 'primary-link' | 'secondary-link';
  onClick?: MouseEventHandler<HTMLButtonElement>;
  isDisabled?: boolean;
  buttonSize?: 's' | 'm' | 'l';
  hasIcon?: boolean;
  isHidden?: boolean;
  $isInlineLink?: boolean;
  $alignRight?: string;
  dataTestId?: string;
}

export const Button: FC<ButtonProps> = ({
  label,
  variant,
  buttonSize = 's',
  onClick,
  isDisabled = false,
  hasIcon = false,
  isHidden = false,
  $isInlineLink = false,
  $alignRight,
  dataTestId,
}) => {
  return (
    <ButtonContainer $variant={variant} $buttonSize={buttonSize} $isHidden={isHidden} $isInlineLink={$isInlineLink} $alignRight={$alignRight}>
      <ButtonStyles $variant={variant} onClick={onClick} disabled={isDisabled} $buttonSize={buttonSize} $alignRight={$alignRight} data-testid={dataTestId}>
        {hasIcon && <PlusIcon />}
        {label}
      </ButtonStyles>
    </ButtonContainer>
  );
};
